import FeesService from "@/services/FeesService";

const INITIAL_PAGINATION = {
  pageIndex: 0,
  pageSize: 0,
  totalElements: 0,
  totalPages: 0
}

const state = {
  fees: [],
  pagination: { ...INITIAL_PAGINATION },
}

const mutations = {
  setFees(state, value) {
    state.fees = value;
  },
  setPagination(state, value) {
    state.pagination = value;
  },
}

const getters = {
  fees: state => state.fees,
  feesPagination: state => state.pagination
}

const actions = {
  getPrefilledFees (_, payload) {
    return FeesService.getFees(payload);
  },

  createFees (_, payload) {
    return FeesService.createFees(payload);
  },

  deleteFees (_, payload) {
    return FeesService.deleteFees(payload);
  },

  updateFees (_, payload) {
    return FeesService.updateFees(payload);
  },

  exportCsv(_, payload) {
    return FeesService.exportCsv(payload);
  },
  async getFees({commit}, payload) {
    try {
      const {list, pagination} = await FeesService.getFees(payload);
      commit("setFees", list);
      commit("setPagination", pagination);
    } catch (error) {
      commit("setFees", []);
      commit("setPagination", INITIAL_PAGINATION);
    }
  },
  async uploadFees(_, payload) {
    return await FeesService.uploadFees(payload);
  },
  async previewFees(_, payload) {
    return await FeesService.previewFees(payload);
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};